
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form, Spinner } from "reactstrap";
import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
// Toast Notifications
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// AWS Amplify Auth
import { resetPassword } from '@aws-amplify/auth';

// import images
import logoLight from "../../assets/images/darkLogo1.png";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

const ForgetPasswordPage = (props) => {
  const [resetError, setResetError] = useState("");
  const [resetSuccess, setResetSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email address").required("Please Enter Your Email"),
    }),
    onSubmit: async (values) => {
      setLoading(true)
      try {
        // Trigger AWS Amplify forgotPassword
        const { nextStep } = await resetPassword({ email: values.email, username: values.email });
        switch (nextStep.resetPasswordStep) {
          case 'CONFIRM_RESET_PASSWORD_WITH_CODE':
            const codeDeliveryDetails = nextStep.codeDeliveryDetails;
            props.router.navigate("/twostep-verification", { state: { username: values.email }, });
            toast.success(
              `Confirmation code was sent to ${codeDeliveryDetails.deliveryMedium}`
            );
            // Collect the confirmation code from the user and pass to confirmResetPassword.
            break;
        }
      } catch (error) {
        toast.error(error.message || "Failed to send reset link.");
        setResetSuccess(""); // Clear success message if error occurs
      }
      setLoading(false)
    }
  });

  document.title = "Whistlemind Demo Engine | Forgot Password";

  return (
    <ParticlesAuth>
      <div className="auth-page-content">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center sm-5 mb-4 text-white-50">
                <div>
                  <Link to="/" className="d-inline-block auth-logo">
                    <img src={logoLight} alt="" height="59" />
                  </Link>
                </div>
                <p className="mt-3 fs-15 fw-medium">Simplifying Office Supplies</p>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="mt-4">
                <CardBody className="p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary"> Forgot Password</h5>
                    
                  </div>

                  <Alert className="border-0 alert-warning text-center mb-2 mx-2" role="alert">
                    Enter your email and instructions will be sent to you!
                  </Alert>

                  <div className="p-2">
                    {resetError && <Alert color="danger" style={{ marginTop: "13px" }}>{resetError}</Alert>}
                    {resetSuccess && <Alert color="success" style={{ marginTop: "13px" }}>{resetSuccess}</Alert>}

                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-4">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="text-center mt-4">
                        <button className="btn btn-success w-100" type="submit">
                        {loading ? <Spinner size="sm" className='me-2'> Loading... </Spinner> : "Send Reset Code"}
                        </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-4 text-center">
                <p className="mb-0">Wait, I remember my password... <Link to="/login" className="fw-semibold text-primary text-decoration-underline"> Click here </Link></p>
              </div>

            </Col>
          </Row>
        </Container>
      </div>

    </ParticlesAuth>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);

